var n = {
  cm: !0,
  mm: !0,
  in: !0,
  px: !0,
  pt: !0,
  pc: !0,
  em: !0,
  ex: !0,
  ch: !0,
  rem: !0,
  vw: !0,
  vh: !0,
  vmin: !0,
  vmax: !0,
  "%": !0
};
function a(e) {
  if (typeof e == "number")
    return {
      value: e,
      unit: "px"
    };
  var t, r = (e.match(/^[0-9.]*/) || "").toString();
  r.includes(".") ? t = parseFloat(r) : t = parseInt(r, 10);
  var u = (e.match(/[^0-9]*$/) || "").toString();
  return n[u] ? {
    value: t,
    unit: u
  } : (console.warn("React Spinners: ".concat(e, " is not a valid css value. Defaulting to ").concat(t, "px.")), {
    value: t,
    unit: "px"
  });
}
function c(e) {
  var t = a(e);
  return "".concat(t.value).concat(t.unit);
}
export {
  c as cssValue,
  a as parseLengthAndUnit
};
//# sourceMappingURL=unitConverter.es.js.map
